import { Injectable } from '@angular/core';
import {CookieService} from "./cookie.service";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  constructor(private cookie: CookieService) { }

  isLoggedIn() {
    // Кука password с 05.09.2026 HttpOnly (бэкенд, kernel::set_auth_cookie) — из JS её не видно,
    // признак входа — только email. Сервер всё равно сверяет обе куки на каждом запросе.
    return this.cookie.getCookie('email').length > 0 || this.cookie.getCookie('accesskey').length > 0;
  }
}
